/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
  * Collection card swatches: clicking a swatch swaps the card image in place
  * instead of navigating to the product page. Scoped to grid swatch fieldsets
  * ([data-grid-swatch-fieldset]) so PDP swatches and sibling swatches keep
  * their default behavior. The theme's own GridSwatch element still handles
  * the hover preview; `is-selected` persists the chosen image after the
  * pointer leaves the card (hover cleanup only removes `is-visible`).
  */
  function selectGridSwatch(link) {
    var swatchButton = link.closest('[data-swatch-button]');
    var productItem = link.closest('[data-grid-item]');
    if (!swatchButton || !productItem) return;

    var productImage = productItem.querySelector('[data-product-image]');
    if (!productImage) return;

    // Same quote normalization the theme uses when writing data-variant-title
    var variantName = (swatchButton.getAttribute('data-swatch-variant-name') || '').replace(/"/g, "'");

    productImage.querySelectorAll('[data-variant-title].is-selected').forEach(function(image) {
      image.classList.remove('is-selected');
    });

    var selectedImage = productImage.querySelector('[data-variant-title="' + variantName + '"]');
    if (selectedImage) {
      selectedImage.classList.add('is-selected');
    } else {
      // No pre-rendered variant layer — swap the card's featured image to the
      // variant's featured image (same image the PDP switches to), carried on
      // the chip as data-swatch-image.
      var swatchImage = swatchButton.getAttribute('data-swatch-image');
      var cardImage = productImage.querySelector('[data-product-image-default] img');

      if (swatchImage && cardImage) {
        cardImage.removeAttribute('srcset');
        cardImage.removeAttribute('data-srcset');
        cardImage.src = swatchImage;
      }
    }

    var fieldset = link.closest('[data-grid-swatch-fieldset]');
    if (fieldset) {
      fieldset.querySelectorAll('[data-swatch-button].is-active').forEach(function(button) {
        button.classList.remove('is-active');
      });
    }
    swatchButton.classList.add('is-active');
  }

  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-grid-swatch-fieldset] [data-swatch-link]');
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
    selectGridSwatch(link);
  });

  /*
  * Touch support: iOS treats the first tap on an element with a mouseenter
  * handler that changes the DOM (the theme's tooltip) as hover-only and
  * swallows the click. Handle the tap on touchend ourselves — but only when
  * the finger didn't move, so swiping the swatch row still scrolls it.
  * preventDefault on touchend also stops the emulated mouse events, the
  * tooltip, and the link navigation in one go.
  */
  var touchStartX = 0;
  var touchStartY = 0;

  document.addEventListener('touchstart', function(event) {
    if (!event.target.closest('[data-grid-swatch-fieldset] [data-swatch-link]')) return;
    touchStartX = event.changedTouches[0].clientX;
    touchStartY = event.changedTouches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function(event) {
    var link = event.target.closest('[data-grid-swatch-fieldset] [data-swatch-link]');
    if (!link) return;

    var touch = event.changedTouches[0];
    var moved = Math.abs(touch.clientX - touchStartX) > 10 || Math.abs(touch.clientY - touchStartY) > 10;
    if (moved) return; // it was a scroll/swipe, not a tap

    event.preventDefault();
    event.stopPropagation();
    selectGridSwatch(link);
  }, { passive: false });

  /*
  * $0.00 products: no price, no add to cart on the product page and in the
  * quick-add modal. Liquid already hides the price (snippets/price.liquid) and
  * the add-to-cart form (snippets/product-buttons.liquid) on first render. The
  * theme re-renders the price on variant change but not the buy buttons, so
  * keep the form, the empty price block's spacing and the sticky cart bar in
  * sync from here.
  */
  function syncZeroPrice(productInfo, isZero) {
    var form = productInfo.querySelector('[data-product-form]');
    var priceBlock = productInfo.querySelector('[id^="Price-"]');
    var cartBar = productInfo.querySelector('cart-bar');

    if (form) form.classList.toggle('hidden', isZero);
    if (priceBlock && priceBlock.closest('.product__block')) {
      priceBlock.closest('.product__block').classList.toggle('hidden', isZero);
    }
    if (cartBar) {
      cartBar.classList.toggle('hidden', isZero);
      // The bar's height feeds the footer's bottom padding; recompute it.
      if (typeof cartBar.setCartBarHeight === 'function') cartBar.setCartBarHeight();
    }
  }

  // First render: Liquid hid the form for a $0.00 variant; hide the rest to match.
  function initZeroPrice(productInfo) {
    var form = productInfo.querySelector('[data-product-form]');
    if (form && form.classList.contains('hidden')) syncZeroPrice(productInfo, true);
  }

  document.querySelectorAll('product-info').forEach(initZeroPrice);
  document.addEventListener('theme:product-info:loaded', function(event) {
    if (event.target.matches && event.target.matches('product-info')) initZeroPrice(event.target);
  });

  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function(event) {
      var data = event && event.data;
      if (!data) return;

      document.querySelectorAll('product-info').forEach(function(productInfo) {
        var id = productInfo.dataset.originalSection || productInfo.dataset.section;
        if (id === data.sectionId) syncZeroPrice(productInfo, !!data.variant && data.variant.price === 0);
      });
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
